import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
import store from 'store'
import storeDefaultsPlugin from 'store/plugins/defaults'

import {
    STORE_KEY,
    STORE_DEFAULT
} from '../constants'

Vue.use(VueLocalStorage)

store.addPlugin(storeDefaultsPlugin)

/**
 * 设置Store默认值
 */
const setupStore = () => {
    let defaults = {}
    defaults[STORE_KEY.STORE_KEY_ENV] = STORE_DEFAULT.STORE_DEFAULT_ENV
    defaults[STORE_KEY.STORE_KEY_NOT_PERMISSION_TIPS] = STORE_DEFAULT.STORE_DEFAULT_NOT_PERMISSION_TIPS
    store.defaults(defaults)
}

setupStore()

export default {
    /**
     * Utils.exportExcelWeighting(url, token[, alertFn, that, loading])
     * @param {string} url      下载路径
     * @param {string} token    token
     * @param {Function} alertFn  传入弹框提示函数
     * @param {Object} that     loading绑定的对象，顶层对象需要传入this，未绑定可不传
     * @param {string} loading  loading名称，未绑定可不传
     * @param {string} params   当前点击下载的按钮加loading,单个下载/导出可以不传，一般用于列表多个下载
     */
    async exportExcelWeighting(url, token, alertFn, that, loading, params) {
        if (typeof(params) == 'object') {
          that.$set(params.row, '$isLoading', true)
        }
        loading ? (that[loading] = true) : "";
        let response = await fetch(url, { headers: { Right: token } });
        // 添加错误处理。
        if (response.headers.get("Content-Type").indexOf('json') > 0) {
            response.json().then(e => {
                // console.info("exportExcelWeighting====Content-Type", e)
                alertFn ? alertFn({
                    desc: e.msg || e.status + e.message
                }) : alert(e.msg)
            })
        } else {
            response.blob().then(blob => {
                var downUrl = window.URL.createObjectURL(blob),
                    a = window.document.createElement("a"),
                    filename;
                a.setAttribute("href", downUrl);
                console.info("exportExcelWeighting====Content-Disposition", response.headers.get("Content-Disposition"))
                if (response.headers.get("Content-Disposition")) {
                    filename = response.headers.get("Content-Disposition").split('=')[1].replace(/\"/g, "").split(".");
                    a.setAttribute("download", `${ decodeURIComponent( filename[0] ) }.${ filename[1] }`);
                    console.info("Content-Disposition", `${ decodeURIComponent( filename[0] ) }.${ filename[1] }`)  //  <>!@#$%^&*()_+|{}-=.png
                } else {
                    console.info("exportExcelWeighting====downUrl")
                    filename = downUrl.toString().split("-");
                    a.setAttribute('download', filename[filename.length - 1])
                }
                a.click();
                window.URL.revokeObjectURL(downUrl);
            });
        }
        if (params) {
          that.$set(params.row, '$isLoading', false)
        }
        loading ? (that[loading] = false) : "";
    },

    /**
     * Utils.exportAliExcelWeighting(url, header[, alertFn, that, loading])
     * 导出文件- 走阿里云网关
     * @param {string} url      下载路径
     * @param {string} header    阿里云header
     * @param {Function} alertFn  传入弹框提示函数
     * @param {Object} that     loading绑定的对象，顶层对象需要传入this，未绑定可不传
     * @param {string} loading  loading名称，未绑定可不传
     * @param {string} params   当前点击下载的按钮加loading,单个下载/导出可以不传，一般用于列表多个下载
     */
    async exportAliExcelWeighting(url, fileName, header = {}, alertFn, that, loading, params) {
        if (typeof(params) == 'object') {
          that.$set(params.row, '$isLoading', true)
        }
        loading ? (that[loading] = true) : "";
        let response = await fetch(url, { headers: header });
        // 添加错误处理。
        if (response.headers.get("Content-Type").indexOf('json') > 0) {
            response.json().then(e => {
                // console.info("exportExcelWeighting====Content-Type", e)
                alertFn ? alertFn({
                    desc: e.msg || e.status + e.message
                }) : alert(e.msg)
            })
        } else {
            response.blob().then(blob => {
                var downUrl = window.URL.createObjectURL(blob),
                    a = window.document.createElement("a");
                a.setAttribute("href", downUrl);
                a.setAttribute('download', `${fileName}_${new Date().getTime()}.xls`)
                a.click();
                window.URL.revokeObjectURL(downUrl);
            });
        }
        if (params) {
          that.$set(params.row, '$isLoading', false)
        }
        loading ? (that[loading] = false) : "";
    },

    /**
     * Utils.exportAliTsExcelWeighting(url, header[, alertFn, that, loading])
     * 导出文件- 走阿里云网关
     * @param {Function} alertFn  传入弹框提示函数
     * @param {Object} that     loading绑定的对象，顶层对象需要传入this，未绑定可不传
     * @param {string} loading  loading名称，未绑定可不传
     * @param {string} params   当前点击下载的按钮加loading,单个下载/导出可以不传，一般用于列表多个下载
     */
    async exportAliTsExcelWeighting(fetch_fun, fileName, that, loading, params) {
        loading ? (that[loading] = true) : "";
        let response = await fetch_fun();
        console.log("res", response)
        // 添加错误处理。
        if (response == undefined){
            alert('请求异常')
        } else if (response.data.retCode || response.data.code !== '0000') {
            console.log('111111=======')
            alert(response.data.msg)
        } else {
            console.log('22222222=======')
            response.data.list.then(blob => {
                var downUrl = window.URL.createObjectURL(blob),
                    a = window.document.createElement("a");
                a.setAttribute("href", downUrl);
                a.setAttribute('download', `${fileName}_${new Date().getTime()}.xls`)
                a.click();
                window.URL.revokeObjectURL(downUrl);
            });
        }
        if (params) {
          that.$set(params.row, '$isLoading', false)
        }
        loading ? (that[loading] = false) : "";
    },
    /**
     * 
     * @param { Object } obj    get查询的params
     * @param { Array } extArray    排除的字段，非必须
     */
    queryParamsToString(obj, extArray) {
        let arr = Object.keys(obj),
            str = '';
        for (let i = 0; i < arr.length; i++) {
            if (extArray && extArray.indexOf(arr[i]) >= 0) continue
            str += `${arr[i]}=${obj[arr[i]]||""}&`
        }
        return str.slice(0, str.lastIndexOf('&') - 1)
    },
    /**
     * 对象键名替换
     * @param {obj:Object,map:Object} 
     */
    ObjectKeysTransform({ orign, map }) {
        // if (!(map.constructor === Object)) throw new Error("map needs object")
        let flag = false
        if (orign.constructor === Object) {
            flag = true
            orign = [orign]
        }
        if (orign.constructor === Array) {
            let newArr = [],
                newObj = {}
            for (let i = 0; i < orign.length; i++, newObj = {}) {
                for (let j in orign[i]) {
                    if (map[j]) newObj[map[j]] = orign[i][j]
                    else newObj[j] = orign[i][j]
                }
                newArr.push(newObj)
            }
            return flag ? newArr[0] : newArr
        }
    },
    /**
     * 保存某个item到 local storage
     */
    saveToLocalStorage(key, value) {
        Vue
            .localStorage
            .set(key, value)
    },
    /**
     * 查询某个local storage item
     * @param defaultVaule 如果找不到对应key的参数则返回此默认参数
     */
    findFromLocalStorage(key, defaultVaule) {
        return Vue.localStorage.get(key, defaultVaule)
    },
    /**
     * 移除localstorage某个item
     * @param {*} key item key
     */
    removeItemFromLocalStorage(key) {
        Vue
            .localStorage
            .remove(key)
    },

    getFromStore(key) {
        return store.get(key)
    },
    setToStore(key, value) {
        return store.set(key, value)
    },
    removeFromStore(key) {
        return store.remove(key)
    },
    listStore() {
        let data = {}
        store.each((value, key) => {
            data[key] = value
        })
        return data
    },

    /**
     * 获取URL query 参数，可不通过vue router路由获取
     * @param {*} name query param name
     * @param {*} url
     */
    getUrlParameterByName(name, url) {
        if (!url)
            url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results)
            return null;
        if (!results[2])
            return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    },

    /**
     * 校验是否登录，检查local storage的token是否存在
     */
    authValid() {
        const token = this.findFromLocalStorage("vue-token");
        if (token) {
            return true
        } else {
            return false
        }
    },
    /**
     * 获取用户全部功能权限
     * @param menuList gateway登录返回的menu
     */
    parsePermissions(menuList) {
        let permissions = {}

        function changePowerUrl(url) {
            return url
                .replace(/\//g, '_')
                .substr(1)
        }

        menuList.forEach(omsModule => {
            omsModule.childPageList && omsModule.childPageList.forEach(childPage => {
                childPage.powersList && childPage.powersList.forEach(power => {
                    if (power.url) {
                        power.permissionName = changePowerUrl(power.url)
                        permissions[power.permissionName] = power
                    }
                    if (power.ispage === 0) {
                        power.permissionName = power.action
                        permissions[power.permissionName] = power
                    }
                });
            });
        });
        console.log('\n\n\n\n\npermissions:\n' + JSON.stringify(permissions))
        return permissions
    },
    /**
     * 判断用户是否存在某个权限
     * @param  permission
     */
    hasPermission(permission) {
        const permissions = store.get(STORE_KEY.STORE_KEY_PERMISSIONS)
        if (!permissions[permission]) {
            return false
        } else {
            return true
        }
    },
    /**
     * 显示所有权限
     */
    showAllPremission() {
        return store.get(STORE_KEY.STORE_KEY_PERMISSIONS)
    },
    /**
     * 去除对象中空值属性
     * @param obj
     */
    deleteEmptyProperty(obj) {
        let object = JSON.parse(JSON.stringify(obj));
        for (let i in object) {
            let value = object[i];
            if (typeof value === 'object') {
                if (Array.isArray(value)) {
                    if (value.length == 0) {
                        delete object[i];
                        continue;
                    }
                }
                this.deleteEmptyProperty(value);
                if (this.isEmpty(value)) {
                    delete object[i];
                }
            } else {
                if (value === '' || value === null || value === undefined) {
                    delete object[i];
                }
            }
        }
        return object;
    },
    /**
     * 检测对象/数组是否为空
     * @param object 
     */
    isEmpty(object) {
        for (let name in object) {
            return false;
        }
        return true;
    },
    /**
     * 调用阿里云gateway接口，请求头‘x-ca-stage’传入对应环境变量
     * @param env 
     */
    aliHeaderEnv (env) {
        return ['TEST','RELEASE','PRE'][['','release','prepare','','productionk8s','stagingk8s'].indexOf(env) % 3] || 'TEST'
    },
    cleanSources(cleanSource) {
        const cleanSourcesData = [
            { name: '订单系统', value: 1 },
            { name: '丽家会系统', value: 2 },
            { name: 'OMS', value: 3 },
            { name: '微信端', value: 4 },
            { name: 'IOS', value: 5 },
            { name: '第三方', value: 6 },
            { name: 'Android', value: 7 },
            { name: '房东端', value: 8 },
            { name: 'XMS', value: 9 },
            { name: '管家助手', value: 10 },
            { name: 'miniProgram', value: 14 },
        ]
        if(cleanSource){
            const cleanSourceData =  cleanSourcesData.filter(source => cleanSource === source.value )
            return cleanSourceData ? cleanSourceData[0].name : '-';
        }else{
            return cleanSourcesData;
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/index.js